import * as React from 'react';
import Icon, {
  CheckCircleFilled,
  ClockCircleFilled,
  ExclamationCircleOutlined,
  WarningOutlined,
  InfoCircleFilled,
  MailOutlined,
  MehFilled,
  MinusCircleFilled,
  QuestionCircleFilled,
  WarningFilled,
} from '@ant-design/icons';
import { Tooltip } from 'antd';
import { ConversationStatus, useGetThemeQuery } from 'models/graphql';
import { CallBackIcon, useTranslation } from 'utils';
import { MeccaConversationStatus } from 'types/inbox';

interface IProps {
  status: ConversationStatus | MeccaConversationStatus;
  noTooltip?: boolean;
}

export const StatusIndicator: React.FC<IProps> = ({ status, noTooltip }) => {
  const { data: colorsData } = useGetThemeQuery();
  const translate = useTranslation();

  const renderIcon = () => {
    switch (status) {
      case ConversationStatus.Callback:
        return <CallBackIcon />;

      case ConversationStatus.Cancellation:
        return <MinusCircleFilled style={{ color: colorsData?.theme.colors.secondaryDarkShade }} />;

      case ConversationStatus.Finished:
        return <CheckCircleFilled style={{ color: colorsData?.theme.colors.success }} />;

      case ConversationStatus.Info:
        return <InfoCircleFilled style={{ color: colorsData?.theme.colors.primary }} />;

      case ConversationStatus.Open:
        return <ClockCircleFilled style={{ color: 'var(--color__dark-blue)' }} />;

      case ConversationStatus.Question:
        return <QuestionCircleFilled style={{ color: colorsData?.theme.colors.primary }} />;

      case ConversationStatus.Urgent:
        return <WarningFilled style={{ color: colorsData?.theme.colors.error }} />;

      case ConversationStatus.Important:
        return <WarningOutlined style={{ color: 'var(--color__badge-high)' }} />;

      case ConversationStatus.CallbackHimself:
        return (
          <Icon
            name="ReturnCallFromCallerSvg"
            style={{ color: colorsData?.theme.colors.secondary }}
          />
        );

      case ConversationStatus.High:
        return <ExclamationCircleOutlined style={{ color: 'var(--color__badge-high)' }} />;

      case ConversationStatus.EmailBack:
        return <MailOutlined style={{ color: colorsData?.theme.colors.success }} />;

      default:
        return <MehFilled style={{ color: colorsData?.theme.colors.primary }} />;
    }
  };

  if (noTooltip) {
    return renderIcon();
  }

  const tooltipTitle = translate(status.toString());

  return <Tooltip title={tooltipTitle}>{renderIcon()}</Tooltip>;
};
